import $ from 'jquery';
import "jquery-validation";
import "jquery-validation/dist/localization/messages_de.js";
// @ts-ignore
window.jQuery = window.$ = $;

// import jQuery from "jquery";
// window.$ = window.jQuery = jQuery; // workaround for https://github.com/parcel-bundler/parcel/issues/333